/**
 * api接口的统一出口
*/
import Login from '@/api/Login';
export default {
    Login
}


// WEBPACK FOOTER //
// ./src/api/index.js